var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('Grid',{style:({ height: 'auto', width: '100%' }),attrs:{"data-items":_vm.dataItem.configDBDetail,"columns":_vm.columns,"resizable":true},on:{"edit":_vm.edit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }